import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { showNotification } from "../../../Services/notificationService";
import { getReverseGeocodedLocation, ReverseGeocodeResult } from "../../LogicActions/FmlmSearch/FmlmGeoService";

export class FmlmReverseGeocodeAction extends BaseAction<
  void,
  { longitude: number; latitude: number }
> {
  override async run(): Promise<void | null> {
    try {
      const { longitude, latitude } = this.params!;
      const location = await getReverseGeocodedLocation(longitude, latitude);

      if (location) {
        updateRecoilState<ReverseGeocodeResult>("fmlmReverseGeoCodeLocationAtom", location);
      } else {
        updateRecoilState("fmlmReverseGeoCodeLocationAtom", null);
      }
    } catch (error) {
      console.error("Error in FmlmReverseGeocodeAction:", error);
    }
  }
}

// Singleton instance
export const fmlmReverseGeocodeAction = new FmlmReverseGeocodeAction();
